if ( document.body.classList.contains('error404')) {
    document.addEventListener("mousemove", sheepAnimate);
}

function sheepAnimate(e)
{
  // this.querySelectorAll('.parallax-sheep').forEach(layer => {
  //
  //     const x = (window.innerWidth / 2 - e.pageX ) / 100
  //     const y = (window.innerHeight / 2 - e.pageY ) / 100
  //
  //     layer.style.transform = `translateX(${x}px) translateY(${y}px)`
  // })

    this.querySelectorAll('.parallax-sheep path:nth-child(7), .parallax-sheep path:nth-child(8)').forEach(layer => {
        const x = -(window.innerWidth / 2 - e.pageX) / 100;
        const y = -(window.innerHeight / 2 - e.pageY) / 100;
        layer.style.transform = `translateY(${y}px) translateX(${x}px)`
    })


}
